import { OntologyFieldType } from 'features/dynamicOntology'
import isNil from 'lodash/isNil'
import { FC } from 'react'

import { EmptyValue, formatValueForDisplay } from './utils'

export interface PropertyValueRendererProps {
  type: OntologyFieldType
  value: unknown
}

export const PropertyValueRenderer: FC<PropertyValueRendererProps> = ({
  type,
  value,
}) => {
  if (isNil(value) || value === '') {
    return <EmptyValue>—</EmptyValue>
  }

  const displayValue = formatValueForDisplay(value, type)
  return <span>{displayValue}</span>
}
